<template>
    <div v-if="cruiseInfo" :class="$style.container">
        <div v-if="cruiseInfo.images.length > 4" :class="$style.thumbnail">
            <Swiper ref="smallSwiperRef" :class="$style.thumbnail_swiper" :options="thumbsOption">
                <SwiperSlide :class="$style.slide" v-for="(img, i) in cruiseInfo.images" :key="i">
                    <img :class="$style.slide_img" :src="img" :alt="cruiseInfo.title" />
                </SwiperSlide>
            </Swiper>
        </div>
        <div :class="$style.main">
            <div :class="$style.main_swiper_wraper">
                <Swiper ref="mainSwiperRef" :key="mainSwiperId" :class="$style.main_swiper" :options="mainOption">
                    <SwiperSlide :class="$style.slide" v-for="(img, i) in cruiseInfo.images" :key="i">
                        <img :class="$style.slide_img" :src="img" :alt="cruiseInfo.title" />
                    </SwiperSlide>

                    <div :class="$style.swiper_btn" class="swiper-button-next" slot="button-next"></div>
                    <div :class="$style.swiper_btn" class="swiper-button-prev" slot="button-prev"></div>
                </Swiper>

                <div :class="$style.main_swiper_mask">
                    <nuxt-link :to="`/company/cruise/${cruiseInfo.id}`" target="_blank">{{ cruiseInfo.title }} <i
                            class="el-icon-arrow-right" /></nuxt-link>
                </div>
            </div>
            <div :class="$style.cruise_wraper">
                <div :class="$style.cruise_detail">首航：{{ cruiseInfo.first_time }}</div>
                <div :class="$style.cruise_detail">甲板：{{ cruiseInfo.floor }}</div>
                <div :class="$style.cruise_detail">载客量：{{ cruiseInfo.passenger }}</div>
                <div :class="$style.cruise_detail">吨位：{{ cruiseInfo.tonnage }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    defineComponent, onMounted, ref, watchEffect, computed, nextTick, watch
} from "@nuxtjs/composition-api";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default defineComponent({
    name: 'CruiseInfo',
    components: {
        Swiper,
        SwiperSlide
    },
    props: {
        cruiseInfo: {
            type: Object,
            default: () => null
        }
    },
    setup(props) {
        /** @type { import('vue').ComputedRef<import("swiper").SwiperOptions> } */
        const thumbsOption = computed(() => ({
            direction: 'vertical',
            spaceBetween: 10,
            slidesPerView: 5,
            touchRatio: 0.2,
            slideToClickedSlide: true
        }));
        const smallSwiperRef = ref();

        const thumbsSwiper = computed(() => {
            return smallSwiperRef.value ? smallSwiperRef.value.$swiper : null;
        })

        /** @type { import('vue').ComputedRef<import("swiper").SwiperOptions> } */
        const mainOption = computed(() => ({
            spaceBetween: 10,
            thumbs: { swiper: thumbsSwiper.value },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        }));
        const mainSwiperRef = ref();
        const mainSwiperId = ref(0);



        watch(thumbsSwiper, () => {
            if (thumbsSwiper.value) {
                nextTick(() => {
                    mainSwiperId.value++
                })
            }
        })

        return {
            thumbsOption,
            thumbsSwiper,
            mainSwiperId,
            mainOption,

            smallSwiperRef,
            mainSwiperRef
        }
    }
})
</script>

<style lang="scss" module>
.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  height: 16rem;
}
.thumbnail {
  margin-right: 0.5rem;
  width: 3.75rem;
}
.thumbnail_swiper {
  height: 16rem;
}
.thumbnail_swiper :global(.swiper-slide-thumb-active) {
  border-color: var(--border-color-darker);
  border-width: 1px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
}
.thumbnail .slide {
  border-radius: 0.25rem;
  -o-object-fit: cover;
  object-fit: cover;
}
.thumbnail .slide_img {
  border-radius: 0.25rem;
  height: 100%;
  width: 100%;
}
.main {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
  border-width: 1px;
  width: 18.75rem;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
}
.main_swiper {
  height: 12.5rem;
}
.main_swiper_wraper {
  border-radius: 0.25rem;
  overflow: hidden;
  position: relative;
}
.main_swiper_mask {
  font-size: 1rem;
  line-height: 1.5rem;
  padding: 0.75rem;
  padding-top: 1.5rem;
  position: absolute;
  left: 0px;
  bottom: 0px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
  z-index: 10;
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
}
.main .swiper_btn {
  --swiper-navigation-size: 24px;
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  border-radius: 9999px;
  border-width: 1px;
  height: 2.25rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 2.25rem;
}
.main .slide {
  border-radius: 0.25rem;
}
.main .slide_img {
  border-radius: 0.25rem;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
}
.cruise_wraper {
  display: -ms-grid;
  display: grid;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  -webkit-row-gap: 0.25rem;
  -moz-row-gap: 0.25rem;
  grid-row-gap: 0.25rem;
  row-gap: 0.25rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.cruise_detail {
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  font-size: 0.75rem;
  line-height: 1rem;
}
</style>